import classNames from "classnames/bind";
import styles from "./StreamCam.module.css";
import { useContext, useEffect, useRef, useState, useSyncExternalStore } from "react";
import useWindowSize from "../../../../hooks/useWindowSize";
import { icon_ai, mokeForTurnOnFaceDetect } from "./ConfigColor";
import { Tooltip } from "antd";
import { checkTime, listAiTranslate, SCECHULE } from "../../../../utils";
import { Loading, Toast } from "../../../../components";
import { configDefault } from "../../../../services/api/configDefault";
import { aiConfigService } from "../../../../services/api/aiConfigService";
import { CameraContext } from "../../LiveCamera";
import { aiConfigFRS } from "../../../../services/api/aiConfigFRS";
import axiosClient from "../../../../services/axiosClient";
import { useTranslation } from "react-i18next";
import { AI } from "../../../../components/Icons/Stream/AI";

const cx = classNames.bind(styles)
const ListAiHeader = ({ infoAi, restartCamera, screen }) => {
    const refPlaceIconAi = useRef(null);
    const [width, height] = useWindowSize();
    const [showOneIconAi, setShowOneIconAi] = useState(false);
    const { t } = useTranslation()
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [roleService, setRoleService] = useState(false);
    const [listAiActive, setListAiActive] = useState([]);

    useEffect(() => {
        // console.log(width);

        let isSize = refPlaceIconAi.current?.offsetWidth < 164;
        setShowOneIconAi(isSize);
    }, [refPlaceIconAi.current?.offsetWidth, width])

    useEffect(() => {
        setRoleService(localStorage.getItem("role")?.split(",")?.some(role => role === "S" || role === "A"))
        setListAiActive(infoAi?.list_ai_service);
        const listAiRegister = infoAi?.list_ai_service_registed?.map(ai => {
            const ai_active = icon_ai.find(icon => icon.ai_service_code === ai.ai_service_code);
            return ai_active;
        })
        setServices(listAiRegister)
    }, [infoAi?.list_ai_service, infoAi?.list_ai_service_registed, icon_ai])
    // Kiểm tra trạng thái AI
    const handleCheckStatusAi = (serviceCode) => {
        // Nếu trạng thái đang bật trả ra '#00B335'
        if (listAiActive?.some(ai => ai?.ai_service_code === serviceCode)) return true;
        return false
    }

    // Refresh sau khi thao tác
    const handleAutoRefresh = (cameraCode) => {
        restartCamera(cameraCode, false)
        setLoading(false)
    }

    // lấy danh sách cấu hình mặc định của các AI trong hệ thống
    const getListDefaultConfig = async (serviceCode) => {
        try {
            const res = await configDefault.getAllConfig();
            if (res && res?.data) {
                const listConfigDefault = res?.data?.filter(item => item?.TYPE === serviceCode || item?.TYPE === "AI")
                return listConfigDefault;
            }
            return []
        } catch (error) {
            throw error;
        }
    }
    //lấy danh sách cấu hình mặc định của nhận dạng mặt
    const getListDefaultConfigFaceDetect = async () => {
        try {
            const res = await aiConfigFRS.getListAiParams()
            if (res) {
                const listCodeParam = res?.map(param => {
                    const valueDefault = param?.aiParamLevels?.find(paLevel => paLevel?.isDefault === 1)?.id;
                    return valueDefault
                })
                return listCodeParam
            }
            return []
        } catch (error) {
            // console.log('getListDefaultConfigFaceDetect', error);
            throw error;
        }
    }
    // Phân chia những giá trị cấu hình
    const getUnitParam = (listParram, serviceCode, cameraCode) => {
        let time_keeping = "14";
        let code = [];
        let commonConfig = {};
        if (listParram) {
            time_keeping = listParram?.find(pram => pram?.KEY === "TIME_KEEPING_EVENT_DEFAULT")?.VALUE;
            const listAiParam = listParram?.filter(param => !SCECHULE.some(key => key === param?.KEY))
            const listCommonParam = listParram?.filter(param => SCECHULE.some(key => key === param?.KEY)
                && param?.KEY !== "TIME_KEEPING_EVENT_DEFAULT"
                && param?.KEY !== "TIME_ALERT_EVENT"
                && param?.KEY !== "CARE_CLASSES")
            listAiParam?.forEach(aiPa => {
                if (serviceCode === '20230222000000000008') {
                    code.push(aiPa?.AI_PARAM_LEVEL_CODE)
                } else {
                    code.push(aiPa?.VALUE)
                }
            });
            listCommonParam?.forEach(comParam => {
                switch (comParam?.KEY) {
                    case "TIME_START_ACTIVE":
                        commonConfig.time_start = comParam?.VALUE
                        break;
                    case "TIME_END_ACTIVE":
                        commonConfig.time_end = comParam?.VALUE
                        break;
                    default:
                        commonConfig[`${comParam?.KEY?.toLowerCase()}`] = comParam?.VALUE
                        break;
                }
            })
            return {
                time_keeping,
                infoConfig: {
                    ai_param_level_code: { code: code },
                    ai_service_code: serviceCode,
                    camera_code: cameraCode,
                    ...commonConfig
                }
            }
        }
    }

    // Bật dịch vụ thông thường
    const handleTurnOnNormalAi = async (serviceCode, cameraCode) => {
        try {
            const defaultConfig = await getListDefaultConfig(serviceCode);
            const paramAiConfig = getUnitParam(defaultConfig, serviceCode, cameraCode)
            // Cấu hình thời gian lưu trữ, cần có time_keeping và camera_code _ aiConfigService.configAi
            const timeKeepingInfo = {
                cameraid: cameraCode,
                time_keeping: paramAiConfig?.time_keeping ? Number(paramAiConfig?.time_keeping) : 14
            }
            await aiConfigService.configAi(timeKeepingInfo)
            // Cấu hình khác aiConfigService.update
            await aiConfigService.update(paramAiConfig.infoConfig)
        } catch (error) {
            // console.log('handleTurnOnNormalAi', error);
            throw error;
        }
    }
    // Lấy thông tin cam
    const getCameraInfo = async (cameraCode) => {
        try {
            const res = await axiosClient.get(
                `cameraManagement/get-camera-info-by-code/?camera_code=${cameraCode}`
            );
            return ({
                company_code: res[0]?.COMPANY_CODE,
                company_name: res[0]?.COMPANY_NAME
            })
        } catch (e) {
            // console.log(e);
        }
    };

    // Bật ai
    const handelTurnOnAi = async (serviceCode, cameraCode, serviceName) => {
        try {
            // Nếu bật dịch vụ khác dịch vụ phát hiện chuyển động thì bật thêm phát hiện chuyển động
            // Bật theo cấu hình mặc định
            if (serviceCode !== '20230222000000000001') {
                // Kiểm tra trạng thái của phát hiện chuyển động 
                const statusMotionDetect = handleCheckStatusAi("20230222000000000001")
                // Nếu bật cảnh báo cháy thì không cần bật chuyển động, nhưng cần kiểm tra cam là cam hik hay không.
                if (serviceCode === "20230222000000000007") {
                    if (infoAi.type_camera === 'HIK') {
                        const defaultConfig = await getListDefaultConfig(serviceCode);
                        const infoConfig = {
                            camera_code: cameraCode,
                            enabled: `true`,
                            alarm: defaultConfig?.find(cf => cf?.KEY === "ALARM")?.VALUE || "105",
                        }
                        await aiConfigService.postAddHikFireDetectConfig(infoConfig)
                        Toast.open(`${t("stream.turnOn")} ${serviceName?.toLowerCase()} ${t("stream.success")}`, "success")
                        handleAutoRefresh(cameraCode)
                        setListAiActive(pre => [...pre, { ai_service_code: serviceCode }])
                    } else {
                        Toast.open(t("stream.brandNotSupportFireDetect"), "danger")
                        setLoading(false)
                    }
                }
                // Nhận dạng khuôn mặt bật theo API khác + nhận dạng biển số vs mặt ko cần bật theo motion
                else if (
                    serviceCode === "20230222000000000002"
                    || serviceCode == '20230222000000000006'
                    || serviceCode !== "20230222000000000007"
                    || serviceCode === "20230222000000000008"
                ) {
                    if (serviceCode === "20230222000000000002") {
                        // Nhận dạng mặt
                        const listDefaultConfig = await getListDefaultConfigFaceDetect();
                        const companyInfo = await getCameraInfo(cameraCode);
                        // editConfig
                        const infoConfig = {
                            cameraCode: cameraCode,
                            aiParamsLevelIds: listDefaultConfig,
                            serviceCode: "20230222000000000002",
                            companyCode: companyInfo?.company_code || "",
                            companyName: companyInfo?.company_name || "",
                        }
                        await aiConfigFRS.editConfig(infoConfig)
                        const infoFakeTurnOnFace = {
                            ...mokeForTurnOnFaceDetect,
                            camera_code: cameraCode
                        }
                        await aiConfigService.update(infoFakeTurnOnFace)
                    } else {
                        console.log('run turn ai');
                        
                        await handleTurnOnNormalAi(serviceCode, cameraCode);
                    }
                    Toast.open(`${t("stream.turnOn")} ${serviceName?.toLowerCase()} ${t("stream.success")}`, "success")
                    setListAiActive(pre => [...pre, { ai_service_code: serviceCode }, { ai_service_code: '20230222000000000001' }])
                    handleAutoRefresh(cameraCode)
                } else {
                    if (!statusMotionDetect) {
                        await handleTurnOnNormalAi("20230222000000000001", cameraCode)
                    }
                    await handleTurnOnNormalAi(serviceCode, cameraCode)
                    setListAiActive(pre => [...pre, { ai_service_code: serviceCode }, { ai_service_code: '20230222000000000001' }])
                    Toast.open(`${t("stream.turnOn")} ${serviceName?.toLowerCase()} ${t("stream.success")}`, "success")
                    handleAutoRefresh(cameraCode)
                }
            } else {
                await handleTurnOnNormalAi(serviceCode, cameraCode)
                Toast.open(`${t("stream.turnOn")} ${serviceName?.toLowerCase()} ${t("stream.success")}`, "success")
                handleAutoRefresh(cameraCode)
                setListAiActive(pre => [...pre, { ai_service_code: serviceCode }])
            }
        } catch (error) {
            // console.log("handelTurnOnAi", error);
            if (error?.response?.data?.message) {
                Toast.open(error?.response?.data?.message, "danger")
            } else if (error.response.status === 403) {
                Toast.open(t("stream.noPermissionTurnAI"), "danger")
            } else {
                Toast.open(`${t("stream.turnOn")} ${serviceName?.toLowerCase()} ${t("stream.error")}`, "danger")
            }
            setLoading(false)
        }
    }

    // Tắt các AI thông thường
    const handleTurnOffNormalAi = async (serviceCode, cameraCode) => {
        try {
            await aiConfigService.remove(cameraCode, serviceCode)
        } catch (error) {
            // console.log("handleTurnOffNormalAi", error);
            throw error;
        }
    }

    // Tắt nhận dạng mặt
    const handleTurnOffFaceDetect = async (serviceCode, cameraCode) => {
        try {
            const param = {
                camera_code: cameraCode,
                ai_service_code: serviceCode
            }
            await aiConfigFRS.deleteConfig(param)
        } catch (error) {
            // console.log("handleTurnOffFaceDetect", error);
            throw error;
        }
    }
    // Tắt Ai
    const handelTurnOffAi = async (serviceCode, cameraCode, serviceName) => {
        try {
            // Nếu tắt chuyển động sẽ tắt tất các chức năng khác trừ báo cháy, nhận dạng mặt, biển số xe.
            if (serviceCode !== '20230222000000000001') {
                // Báo cháy
                if (serviceCode === "20230222000000000007") {
                    if (infoAi.type_camera === 'HIK') {
                        await handleTurnOffNormalAi(serviceCode, cameraCode)
                        handleAutoRefresh(cameraCode)
                        Toast.open(`${t("stream.turnOff")} ${serviceName?.toLowerCase()} ${t("stream.success")}`, "success")
                        setListAiActive(listAiActive?.filter(ai => ai?.ai_service_code !== serviceCode))
                    } else {
                        Toast.open(t("stream.brandNotSupportFireDetect"), "danger")
                        setLoading(false)
                    }
                    // Nhận dạng mặt
                } else if (serviceCode === "20230222000000000002") {
                    await handleTurnOffFaceDetect(serviceCode, cameraCode)
                    Toast.open(`${t("stream.turnOff")} ${serviceName?.toLowerCase()} ${t("stream.success")}`, "success")
                    setListAiActive(listAiActive?.filter(ai => ai?.ai_service_code !== serviceCode))
                    handleAutoRefresh(cameraCode)
                } else {
                    await handleTurnOffNormalAi(serviceCode, cameraCode);
                    Toast.open(`${t("stream.turnOff")} ${serviceName?.toLowerCase()} ${t("stream.success")}`, "success")
                    setListAiActive(listAiActive?.filter(ai => ai?.ai_service_code !== serviceCode))
                    handleAutoRefresh(cameraCode)
                }
            } else {
                // Tắt tất cả các dịch vụ của cam trừ nhận dạng mặt và nhận dạng biển số 
                const listAiOn = infoAi?.list_ai_service || [];
                for (const ai of listAiOn) {
                    if (
                        ai?.ai_service_code !== "20230222000000000002"
                        && ai?.ai_service_code !== "20230222000000000007"
                        && ai?.ai_service_code !== "20230222000000000006"
                        && ai?.ai_service_code !== "20230222000000000008"
                    ) {
                        await handleTurnOffNormalAi(ai?.ai_service_code, cameraCode)
                    }
                }
                setListAiActive(listAiActive?.filter(ai => ai?.ai_service_code === '20230222000000000007'))
                Toast.open(`${t("stream.turnOff")} ${serviceName?.toLowerCase()} ${t("stream.success")}`, "success")
                handleAutoRefresh(cameraCode)
            }
        } catch (error) {
            // console.log("handelTurnOffAi", error);
            if (error?.response?.data?.message) {
                Toast.open(error?.response?.data?.message, "danger")
            } else if (error?.response?.status === 403) {
                Toast.open(t("stream.noPermissionTurnAI"), "danger")
            }
            else {
                Toast.open(`${t("stream.turnOff")} ${serviceName?.toLowerCase()} ${t("stream.error")}`, "danger")
            }
            setLoading(false)
        }
    }
    // bật tắt ai, nếu đang bật thì tắt đi, nếu đang tắt thì bật lên status = true là đang bật
    const hendleTurnAi = (serviceCode, status, serviceName) => {
        const cammeraCode = infoAi?.code;
        setLoading(true)
        if (status) {
            handelTurnOffAi(serviceCode, cammeraCode, serviceName)
        } else {
            handelTurnOnAi(serviceCode, cammeraCode, serviceName)
        }
    }
    return (
        <>
            {roleService && services?.length > 0 && <div className={cx("icon-ai")} ref={refPlaceIconAi} style={screen && screen?.total > 4 ? { flex: 0.1 } : {}}>
                {!showOneIconAi ? (
                    <>
                        {services?.map(item => {
                            // lấy màu của trạng thái ai nếu bật thì là '#00B335' để tự động có màu xanh, tắt truyền màu trắng
                            const status = handleCheckStatusAi(item?.ai_service_code);
                            let color = status ? '#00B335' : 'white';
                            return (
                                <Tooltip placement="top" title={listAiTranslate?.find(ai => ai.ai_name === item?.ai_name)?.name_tr || item?.ai_name}>
                                    <span
                                        key={item?.ai_service_code}
                                        onClick={() => hendleTurnAi(item?.ai_service_code, status, item?.ai_name)}>
                                        {item?.icon(color) || ""}
                                    </span>
                                </Tooltip>
                            )
                        })}
                    </>
                ) : (
                    <div className={cx('ai')}>
                        <AI color={listAiActive?.length > 0
                            ? (checkTime(infoAi.time_start, infoAi.time_end) ? "#00B335" : "#E7A700")
                            : 'white'} />
                    </div>
                )}
                {loading && <div className={cx('load_ai')}><Loading size={2} width={20} /></div>}
            </div >}
        </>
    )
}

export default ListAiHeader;